import { Typography } from '@mui/material';
import { useRef } from 'react';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { ArticlePurchaseInformation } from '@work4all/models/lib/Classes/ArticlePurchaseInformation.entity';

import { SupplierPricePicker } from '../../../../../../components/data-tables/offers-table/components/SupplierPricePicker/SupplierPricePicker';

import {
  PickerTargetButton,
  PickerTargetButtonProps,
} from './PickerTargetButton';

export function SupplierPricePickerCell(
  props: {
    value: string;
    onChange: (value: ArticlePurchaseInformation | null) => void;
    articleId: number;
    onlySuppliersWithPurchasePrice?: boolean;
  } & Omit<PickerTargetButtonProps, 'onChange' | 'value'>
) {
  const {
    disabled: _disabled = false,
    value,
    onChange,
    articleId,
    onlySuppliersWithPurchasePrice,
    ...buttonProps
  } = props;
  const popoverRef = useRef<EntityPickerPopover>(null);

  return (
    <EntityPickerPopover
      ref={popoverRef}
      width={800}
      picker={
        <SupplierPricePicker
          value={null}
          onChange={onChange}
          articleId={articleId}
          onlySuppliersWithPurchasePrice={onlySuppliersWithPurchasePrice}
        />
      }
    >
      <PickerTargetButton {...buttonProps}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography>{value}</Typography>
        </div>
      </PickerTargetButton>
    </EntityPickerPopover>
  );
}
